module.exports = __webpack_public_path__ + "7ebbb886777e0e125ec401926eeedda4.MP3";